import '@babel/polyfill'

import Vue from 'vue'
import Router from 'vue-router'

import Login from '../views/Login'

import ProjectIndex from '../views/projects/Index'
import ProjectCreate from '../views/projects/Create'
import ProjectEdit from '../views/projects/Edit'
import ProjectShow from '../views/projects/Show'

import SettingsLayout from '../views/settings/Layout'
import GroupsIndex from '../views/settings/groups/Index'
import GroupsShow from '../views/settings/groups/Show'
import GroupsCreate from '../views/settings/groups/Create'
import GroupsEdit from '../views/settings/groups/Edit'

import OsdaUserIndex from '../views/settings/osda_user/Index'
import OsdaUserShow from '../views/settings/osda_user/Show'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        auth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        auth: false
      }
    },
    {
      path: '/projects',
      name: 'projects.index',
      component: ProjectIndex,
      meta: {
        auth: true
      }
    },
    {
      path: '/projects/create',
      name: 'projects.create',
      component: ProjectCreate,
      meta: {
        auth: true
      }
    },
    {
      path: '/projects/:id',
      name: 'projects.show',
      component: ProjectShow,
      meta: {
        auth: true
      }
    },
    {
      path: '/projects/:id/edit',
      name: 'projects.edit',
      component: ProjectEdit,
      meta: {
        auth: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: SettingsLayout,
      beforeEnter: (to, from, next) => {
        if (Vue.auth.user() && Vue.auth.user().role === 'osda') {
          next()
        } else {
          next('/projects')
        }
      },
      children: [
        {
          path: 'groups',
          name: 'settings.groups.index',
          component: GroupsIndex
        },
        {
          path: 'groups/create',
          name: 'settings.groups.create',
          component: GroupsCreate
        },
        {
          path: 'groups/:id',
          name: 'settings.groups.show',
          component: GroupsShow
        },
        {
          path: 'groups/:id/edit',
          name: 'settings.groups.edit',
          component: GroupsEdit
        },
        {
          path: 'osda-users',
          name: 'settings.osda-users.index',
          component: OsdaUserIndex
        },
        {
          path: 'osda-users/:id',
          name: 'settings.osda-users.show',
          component: OsdaUserShow
        }
      ],
      meta: {
        auth: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/js/router/index.js